import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import { Swiper, SwiperSlide } from "swiper/react"
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper/modules"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { getLinkTarget } from "@/utils/helper"
import { applyLocaleToUrl } from "@/utils/formatters"

export default function MobileHomeCarousel(props) {
  const router = useRouter()
  const { locale } = router
  const { carouselItem } = props
  const [count, setCount] = useState(0)
  const [mobilePart, setMobilePart] = useState({
    label: "",
    url: "",
  })

  useEffect(() => {
    const swiperEl = document.querySelector(".koh-swiper")

    if (!swiperEl) return

    const showArrows = () => {
      swiperEl.classList.add("show-arrows")

      setTimeout(() => {
        swiperEl.classList.remove("show-arrows")
      }, 2000)
    }
    swiperEl.addEventListener("pointerdown", showArrows)

    return () => {
      swiperEl.removeEventListener("pointerdown", showArrows)
    }
  }, [])

  useEffect(() => {
    const {
      fields: {
        cta: [{ fields: { label: ctaLabel = "" } = {} } = {}] = [],
        mobileCta: [
          { fields: { label: mobilectaLabel = "", url: mobileUrl } = {} } = {},
        ] = [],
      } = {},
    } = carouselItem?.[count] ?? {}

    setMobilePart(prev => ({
      ...prev,
      label: mobilectaLabel,
      url: mobileUrl,
    }))
  }, [count])

  return (
    <div className="koh-carousel">
      <div className="relative mobile-view-carousel">
        {mobilePart?.label ? (
          <>
            <a
              onTouchStart={e => {
                e.currentTarget.style.backgroundColor = "#bebebe"
                e.currentTarget.style.color = "#ffffff"
              }}
              onTouchEnd={e => {
                e.currentTarget.style.backgroundColor = "#ffffff" // back to white
                e.currentTarget.style.color = "#000000" // back to black
              }}
              href={applyLocaleToUrl(mobilePart?.url || undefined, locale)}
              target={getLinkTarget(mobilePart?.url)}
              rel="noopener noreferrer"
              className="bg-[#fff] px-4 py-3 text-[12px] koh-banner-cta uppercase shadow-lg mt-[15px] font-[helveticaBold, Helvetica, sans-serif]"
            >
              {mobilePart?.label}
            </a>
          </>
        ) : null}
      </div>

      <Swiper
        modules={[EffectFade, Navigation, Pagination, Autoplay]}
        effect="fade"
        onSlideChange={swiper => {
          setCount(swiper.realIndex)
        }}
        fadeEffect={{ crossFade: true }}
        speed={2000}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        loop={carouselItem?.length > 1}
        loopPreventsSliding={false}
        navigation
        pagination={{ clickable: true }}
        className="koh-swiper"
      >
        {carouselItem?.map(item => {
          const {
            fields: {
              ["mobileMediaItem"]: [
                {
                  fields: {
                    asset: {
                      fields: {
                        file: { url = "", details: {} = {} } = {},
                        title = "",
                        description = "",
                      } = {},
                    } = {},
                    externalUrl = "",
                    imageUrl = "https://fastly.picsum.photos/id/991/200/300.jpg?hmac=BdTxfK2wHhsGppraQzb5puxPKb5mPVzDaZPz8IiC44Q",
                    imageWidth = 2000,
                    imageHeight = 672,
                    altText = "",
                  } = {},
                } = {},
              ] = [],
            } = {},
          } = item ?? {}

          return (
            <SwiperSlide key={item?.sys?.id}>
              <div className="slide-wrapper">
                <img src={url || imageUrl} alt={`slide-${item?.sys?.id}`} />
              </div>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}
